import en from './en';
import no from './no';

const Translations = { en, no };

export default Translations;
